<ng-container *ngIf="created">
  <div *ngIf="getRetomar();else loadData">
    <h1 class="titulo-principal carga-data">Si ya iniciaste un proceso de <br> contratación retoma aquí.</h1>
    <p class="descripcion-principal">Ingresa tus datos para continuar la solicitud</p>
  </div>
  <ng-template #loadData>
    <h1 class="titulo-principal carga-data">Sobre ti o tu comercio</h1>
    <p class="descripcion-principal">Ingresa tus datos personales o los de tu comercio para comenzar.</p>
  </ng-template>
  <!-- <app-configura-proveedor-servicio-tecnologico></app-configura-proveedor-servicio-tecnologico> -->
  <!-- TODO: eliminar Hidden cuando deje de ocuparse para desarrollo -->
  <div class="card-principal">
    <form [formGroup]="dataPasoUno">

      <!-- TODO: ELIMINAR Cuando se termine unificacion de Login -->
      <!-- <div class="row card--header">
        <div class="col-md-12 card-text--title">¿Cómo quieres vender?</div>
        <div class="col-md-12 seleccion-flujo">
          <mat-radio-group formControlName="seleccionFlujo" [(ngModel)]="personType" (ngModelChange)="radioChangePersonType()" >
            <mat-radio-button tabindex="1" name="personaNatural" value="personaNatural" class="mr-63" >Como persona</mat-radio-button>
            <mat-radio-button tabindex="2" name="personaJuridica" value="personaJuridica" class="radio-persona-juridica" (click)="fixForm()">Como empresa</mat-radio-button>
          </mat-radio-group>
        </div>
      </div> -->

      <div class="row login-unificado">
        <app-login-unificado class="col-md-12" (isRetoma)="isRetoma" (nextStep)="onNextStep($event)"></app-login-unificado>
      </div>

      <!-- <div class="row persona-natural" *ngIf="dataPasoUno.get('seleccionFlujo').value==='personaNatural'">
        <div class="col-md-12 card-text--bajada">
          Quiero vender con mi negocio personal, soy el único propietario y/o emprendedor independiente con o sin inicio de actividades.
        </div>
        <div class="col-md-12 card-text--separator"></div>
        <app-persona-natural *ngIf="isRetoma" class="col-md-12" (nextStep)="onNextStep($event)"></app-persona-natural>
        <app-persona-natural-login *ngIf="!isRetoma" class="col-md-12" (nextStep)="onNextStep($event)"></app-persona-natural-login>
      </div>

      <div class="row mt-36" *ngIf="dataPasoUno.get('seleccionFlujo').value==='personaJuridica'">
        <div class="col-md-12 card-text--bajada">
          Quiero vender con mi empresa, con inicio de actividades.
        </div>
        <div class="col-md-12 card-text--separator"></div>
        <app-persona-juridica-login class="col-md-12" (isRetoma)="isRetoma" (nextStep)="onNextStep($event)"></app-persona-juridica-login>
      </div> -->
    </form>
  </div>
</ng-container>
